// extracted by mini-css-extract-plugin
module.exports =  {"accidental":"Footer__accidental","title":"Footer__title","bodyCaption":"Footer__body-caption","lang":"Footer__lang","rightPart":"Footer__right-part","support":"Footer__support"};